import type { IPropsStore, IStructureStore, Component } from '@wix/thunderbolt-symbols'
import { REPEATER_DELIMITER } from './repeaterUtils'

const COMP_PATH_DELIMITER = '/'

export const getDisplayedIdToCompPath = (
	structureStore: IStructureStore,
	propsStore: IPropsStore
): Record<string, string> => {
	const structure = structureStore.getEntireStore()
	const compIdToCompPath: Record<string, string> = {}

	const buildComponentPath = (
		compId: string,
		component: Component,
		accumulatedPath: string = '',
		currentRepeaterItemsSuffix: string = ''
	): void => {
		const fullPath = `${accumulatedPath}${compId}`
		compIdToCompPath[`${compId}${currentRepeaterItemsSuffix}`] = fullPath

		const childComponentIds = component.components ?? []
		const childPathPrefix = `${fullPath}${COMP_PATH_DELIMITER}`

		if (component.componentType === 'Repeater') {
			const repeaterItemIds = propsStore.get(compId)?.items ?? []
			repeaterItemIds.forEach((repeaterItemId: string) => {
				const newRepeaterItemsSuffix = `${REPEATER_DELIMITER}${repeaterItemId}${currentRepeaterItemsSuffix}`
				const repeaterChildPathPrefix = `${childPathPrefix}${repeaterItemId}${COMP_PATH_DELIMITER}`

				childComponentIds.forEach((childId) => {
					buildComponentPath(childId, structure[childId], repeaterChildPathPrefix, newRepeaterItemsSuffix)
				})
			})
		} else {
			childComponentIds.forEach((childId) =>
				buildComponentPath(childId, structure[childId], childPathPrefix, currentRepeaterItemsSuffix)
			)
		}
	}

	// Process only page components
	Object.entries(structure)
		.filter(([_, component]) => component.componentType === 'Page')
		.forEach(([compId, component]) => buildComponentPath(compId, component))

	return compIdToCompPath
}
